// Verschlüsselung der Geldabholung – läuft NUR im Browser (WebCrypto). Passwort → PBKDF2-SHA256 →
// AES-GCM-256; je Eintrag ein frischer Zufalls-IV, Block = base64(iv + ciphertext). Der Schlüssel ist
// nicht exportierbar und liegt nur im Arbeitsspeicher. Server-Seite: backend/lib/cash_vault.js.

export const b64 = (buf) => { let s = ''; new Uint8Array(buf).forEach((b) => { s += String.fromCharCode(b); }); return btoa(s); };
export const unb64 = (str) => Uint8Array.from(atob(str), (c) => c.charCodeAt(0));
export async function deriveKey(password, saltB64, iterations) {
  const base = await crypto.subtle.importKey('raw', new TextEncoder().encode(password), 'PBKDF2', false, ['deriveKey']);
  return crypto.subtle.deriveKey({ name: 'PBKDF2', salt: unb64(saltB64), iterations, hash: 'SHA-256' }, base, { name: 'AES-GCM', length: 256 }, false, ['encrypt', 'decrypt']);
}
export async function encryptJson(key, obj) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const ct = new Uint8Array(await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, new TextEncoder().encode(JSON.stringify(obj))));
  const out = new Uint8Array(12 + ct.length); out.set(iv, 0); out.set(ct, 12);
  return b64(out);
}
export async function decryptJson(key, blob) {
  const raw = unb64(blob);
  const pt = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: raw.slice(0, 12) }, key, raw.slice(12));
  return JSON.parse(new TextDecoder().decode(pt));
}
export const newId = () => Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => b.toString(16).padStart(2, '0')).join('');
